module.exports = __webpack_public_path__ + "static/media/hahu.cfb4f22d.png";